exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#apple-pay-button {\n\twidth: 250px;\n\theight: 35px;\n\tdisplay: inline-block;\n\t-webkit-appearance: -apple-pay-button;\n\t-apple-pay-button-type: pay;\n\t-apple-pay-button-style: white-outline;\n\tmargin-bottom: -6px;\n\tmargin-top: -5px;\n}\n", ""]);

// exports
